import type { IMultiStepActions } from '@farmshare/ui-components';

import {
  type MergeWizardData,
  selectionPatch,
} from '../hooks/merge-wizard-data';
import { MergeWizardSelectStep } from './merge-wizard-select-step';

export interface MergeWizardSelectModalStepProps {
  data: MergeWizardData;
  actions: IMultiStepActions<MergeWizardData>;
  /** Vendor scope for the search. */
  vendorId: string | undefined;
  /** The customer the wizard was opened from. */
  initiatingId: string;
}

/**
 * Step 1 of the merge wizard — pick the records to merge.
 *
 * Wires `MergeWizardSelectStep` to the multi-step modal's data bag. A change to
 * the set of records goes through `selectionPatch`, which also drops the
 * primary, field choices and consent made about the previous set.
 * @param root0 - Props.
 * @param root0.data - Current wizard data.
 * @param root0.actions - Multi-step actions.
 * @param root0.vendorId - Vendor scope for the search.
 * @param root0.initiatingId - The customer the wizard was opened from.
 * @returns The step body.
 */
export function MergeWizardSelectModalStep({
  data,
  actions,
  vendorId,
  initiatingId,
}: MergeWizardSelectModalStepProps) {
  return (
    <MergeWizardSelectStep
      vendorId={vendorId}
      initiatingId={initiatingId}
      value={data.selected}
      onChange={(next) => actions.updateData(selectionPatch(data, next))}
    />
  );
}
